import Modal from "frontend/modal/modal";
import style from "./uploading-msg.module.css";
import { getPathPrefix } from "utils/getPathPrefix";

export function UploadInProgress() {
  return (
    <Modal dimBackground={true}>
      <div className={style.message}>
        <img src={getPathPrefix("/images/voting-closing.png")} alt="" />
        Preparing results...
      </div>
    </Modal>
  );
}
